'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dIllformed$002dLocale$002dException from "./java.util.-Illformed-Locale-Exception.js";
import * as $j_java$002eutil$002e$002dLocale$0024$0024anon$00241 from "./java.util.-Locale$$anon$1.js";
import * as $j_java$002eutil$002e$002dLocale$0024$002dCategory$0024 from "./java.util.-Locale$-Category$.js";
import * as $j_locales$002ecldr$002e$002dC$002dL$002dD$002dR$002dMetadata from "./locales.cldr.-C-L-D-R-Metadata.js";
import * as $j_locales$002ecldr$002e$002dCalendar$002dPatterns from "./locales.cldr.-Calendar-Patterns.js";
import * as $j_locales$002ecldr$002e$002dCalendar$002dPatterns$0024 from "./locales.cldr.-Calendar-Patterns$.js";
import * as $j_locales$002ecldr$002e$002dCalendar$002dSymbols from "./locales.cldr.-Calendar-Symbols.js";
import * as $j_locales$002ecldr$002e$002dCurrency$002dData from "./locales.cldr.-Currency-Data.js";
import * as $j_locales$002ecldr$002e$002dL$002dD$002dM$002dL$002dLocale from "./locales.cldr.-L-D-M-L-Locale.js";
import * as $j_locales$002ecldr$002e$002dNumber$002dPatterns from "./locales.cldr.-Number-Patterns.js";
import * as $j_locales$002ecldr$002e$002dSymbols from "./locales.cldr.-Symbols.js";
import * as $j_locales$002ecldr$002efallback$002edata$002enumericsystems$0024 from "./locales.cldr.fallback.data.numericsystems$.js";
import * as $j_scala$002e$002dTuple3 from "./scala.-Tuple3.js";
import * as $j_scala$002ecollection$002econvert$002e$002dAs$002dJava$002dExtensions$0024$002dSet$002dHas$002dAs$002dJava from "./scala.collection.convert.-As-Java-Extensions$-Set-Has-As-Java.js";
import * as $j_scala$002ecollection$002econvert$002e$002dAs$002dScala$002dExtensions$0024$002dSet$002dHas$002dAs$002dScala from "./scala.collection.convert.-As-Scala-Extensions$-Set-Has-As-Scala.js";
import * as $j_scala$002ecollection$002emutable$002e$002dMap$0024 from "./scala.collection.mutable.-Map$.js";
import * as $j_scala$002ejdk$002e$002dCollection$002dConverters$0024 from "./scala.jdk.-Collection-Converters$.js";
import * as $j_scala$002escalajs$002ereflect$002e$002dReflect$0024 from "./scala.scalajs.reflect.-Reflect$.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
function $p_ju_Locale__updateSpecialLanguages__T__T($thiz, l) {
  switch (l) {
    case "iw": {
      return "he";
      break;
    }
    case "ji": {
      return "yi";
      break;
    }
    case "in": {
      return "id";
      break;
    }
    default: {
      return l;
    }
  }
}
export { $p_ju_Locale__updateSpecialLanguages__T__T as $p_ju_Locale__updateSpecialLanguages__T__T };
function $p_ju_Locale__translateSpecialLanguages__T__T($thiz, l) {
  return l;
}
export { $p_ju_Locale__translateSpecialLanguages__T__T as $p_ju_Locale__translateSpecialLanguages__T__T };
function $p_ju_Locale__isEqual__ju_Locale__Z($thiz, l) {
  if (((($thiz.zT === l.kU()) && ($thiz.zS === l.r1())) && ($thiz.k5 === l.k5))) {
    var this$1 = $thiz.vw;
    var $x_1 = (this$1.k() || (this$1.C() === l.ub()));
  } else {
    var $x_1 = false;
  }
  if ((($x_1 && $thiz.k4.fQ(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    if ((x$1 !== null)) {
      var k = $j_java$002elang$002e$002dObject.$uC(x$1.ac);
      var v = x$1.ad;
      return (l.UP(k) === v);
    }
    throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x$1);
  })))) && $thiz.m4.fQ(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var k$1 = x$1$2.ac;
      var v$1 = x$1$2.ad;
      return (l.UZ(k$1) === v$1);
    }
    throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x$1$2);
  }))))) {
    var x = $thiz.zU;
    var x$2 = new $j_scala$002ecollection$002econvert$002e$002dAs$002dScala$002dExtensions$0024$002dSet$002dHas$002dAs$002dScala.$c_sc_convert_AsScalaExtensions$SetHasAsScala($j_scala$002ejdk$002e$002dCollection$002dConverters$0024.$m_s_jdk_CollectionConverters$(), l.UY()).Sv();
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
}
export { $p_ju_Locale__isEqual__ju_Locale__Z as $p_ju_Locale__isEqual__ju_Locale__Z };
/** @constructor */
function $c_ju_Locale(language, country, variant, script, _extensions, unicodeExtensions, unicodeAttributes, supportSpecialCases) {
  this.zT = null;
  this.zS = null;
  this.k5 = null;
  this.vw = null;
  this.m4 = null;
  this.zU = null;
  this.vv = null;
  this.vu = 0;
  this.k4 = null;
  this.zT = language;
  this.zS = country;
  this.k5 = variant;
  this.vw = script;
  this.m4 = unicodeExtensions;
  this.zU = unicodeAttributes;
  this.vv = null;
  this.vu = 0;
  if ((((language === null) || (country === null)) || (variant === null))) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__T__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException(), "Null argument to constructor not allowed");
  }
  this.k4 = ((new $j_scala$002e$002dTuple3.$c_T3(language, country, variant).f(new $j_scala$002e$002dTuple3.$c_T3("ja", "JP", "JP")) && supportSpecialCases) ? _extensions.u4($j_java$002elang$002e$002dObject.$m_sc_Map$().e6($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T2.r().C)([new $j_java$002elang$002e$002dObject.$c_T2($j_java$002elang$002e$002dObject.$bC($m_ju_Locale$().vx), "ca-japanese")])))) : ((new $j_scala$002e$002dTuple3.$c_T3(language, country, variant).f(new $j_scala$002e$002dTuple3.$c_T3("th", "TH", "TH")) && supportSpecialCases) ? _extensions.u4($j_java$002elang$002e$002dObject.$m_sc_Map$().e6($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T2.r().C)([new $j_java$002elang$002e$002dObject.$c_T2($j_java$002elang$002e$002dObject.$bC($m_ju_Locale$().vx), "nu-thai")])))) : _extensions));
}
export { $c_ju_Locale as $c_ju_Locale };
$p = $c_ju_Locale.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_Locale;
/** @constructor */
function $h_ju_Locale() {
}
export { $h_ju_Locale as $h_ju_Locale };
$h_ju_Locale.prototype = $p;
$p.kU = (function() {
  var this$1 = this.zT;
  return $p_ju_Locale__translateSpecialLanguages__T__T(this, this$1.toLowerCase());
});
$p.ub = (function() {
  var this$1 = this.vw;
  return (this$1.k() ? "" : this$1.C());
});
$p.r1 = (function() {
  var this$1 = this.zS;
  return this$1.toUpperCase();
});
$p.Pe = (function() {
  return ((!this.k4.k()) || (!this.m4.k()));
});
$p.UP = (function(key) {
  if (((key === $m_ju_Locale$().vx) && (!this.m4.k()))) {
    return $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T(this.m4.ib(new $j_java$002eutil$002e$002dLocale$0024$0024anon$00241.$c_ju_Locale$$anon$1()), "", "-", "");
  } else {
    var this$3 = this.k4.S($j_java$002elang$002e$002dObject.$bC(key));
    return (this$3.k() ? null : this$3.C());
  }
});
$p.UY = (function() {
  return new $j_scala$002ecollection$002econvert$002e$002dAs$002dJava$002dExtensions$0024$002dSet$002dHas$002dAs$002dJava.$c_sc_convert_AsJavaExtensions$SetHasAsJava($j_scala$002ejdk$002e$002dCollection$002dConverters$0024.$m_s_jdk_CollectionConverters$(), this.zU).St();
});
$p.UZ = (function(key) {
  var this$1 = this.m4.S(key);
  return (this$1.k() ? null : this$1.C());
});
$p.b = (function() {
  $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
  var x = this.k5;
  var hasVariant = (x !== "");
  $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
  var x$1 = this.r1();
  var hasCountry = (x$1 !== "");
  $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
  var x$2 = this.kU();
  var hasLanguage = (x$2 !== "");
  $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
  var x$3 = this.ub();
  var hasScript = (x$3 !== "");
  var countryPart = (hasCountry ? ("_" + this.r1()) : ((hasVariant || hasScript) ? "_" : ""));
  var variantPart = (hasVariant ? ("_" + this.k5) : (hasScript ? "_" : ""));
  var scriptPart = ((hasScript && this.Pe()) ? (("#" + this.ub()) + "_") : (hasScript ? ("#" + this.ub()) : (this.Pe() ? "_#" : "")));
  var extensionsPart = $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T(this.k4.a7(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$1) => {
    if ((x$1$1 !== null)) {
      var x$4 = $j_java$002elang$002e$002dObject.$uC(x$1$1.ac);
      var v = x$1$1.ad;
      return (($j_java$002elang$002e$002dObject.$cToS(x$4) + "-") + v);
    }
    throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x$1$1);
  }))), "", "", "");
  return ((hasLanguage || hasCountry) ? ((((this.kU() + countryPart) + variantPart) + scriptPart) + extensionsPart) : "");
});
$p.QI = (function() {
  if ((this.vv === null)) {
    var language = ((($j_java$002elang$002e$002dObject.$m_sc_StringOps$(), (this.kU() !== "")) && $m_ju_Locale$().O8(this.kU())) ? $p_ju_Locale__updateSpecialLanguages__T__T(this, this.kU()) : "und");
    var country = ($m_ju_Locale$().O9(this.r1()) ? ("-" + this.r1()) : "");
    var variantSegments = $j_java$002elang$002e$002dObject.$f_T__split__T__I__AT(this.k5, "-|_", 0);
    _return: {
      var i = 0;
      while ((i < variantSegments.a.length)) {
        var x1 = i;
        var x0 = variantSegments.a[x1];
        if ((!$m_ju_Locale$().Bf(x0))) {
          var allSegmentsWellFormed = false;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var allSegmentsWellFormed = true;
    }
    _return$1: {
      var i$1 = 0;
      while ((i$1 < variantSegments.a.length)) {
        var x1$1 = i$1;
        var x0$1 = variantSegments.a[x1$1];
        if ((!$m_ju_Locale$().SG(x0$1))) {
          var allAcceptableSegments = false;
          break _return$1;
        }
        i$1 = ((1 + i$1) | 0);
      }
      var allAcceptableSegments = true;
    }
    if (allSegmentsWellFormed) {
      var variant = $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T($j_java$002elang$002e$002dObject.$m_s_Predef$().iy(variantSegments), "-", "-", "");
    } else if (allAcceptableSegments) {
      var res1 = new $j_java$002elang$002e$002dObject.$c_scm_ArrayBuilder$generic($j_java$002elang$002e$002dObject.$m_s_reflect_ClassTag$().qT($j_java$002elang$002e$002dObject.$objectGetClass(variantSegments).J.Q()).ch());
      var res2 = new $j_java$002elang$002e$002dObject.$c_scm_ArrayBuilder$generic($j_java$002elang$002e$002dObject.$m_s_reflect_ClassTag$().qT($j_java$002elang$002e$002dObject.$objectGetClass(variantSegments).J.Q()).ch());
      var i$2 = 0;
      while ((i$2 < variantSegments.a.length)) {
        var x1$2 = i$2;
        var x$1 = variantSegments.a[x1$2];
        ($m_ju_Locale$().Bf(x$1) ? res1 : res2).B6(x$1);
        i$2 = ((1 + i$2) | 0);
      }
      var \u03b41$___1 = res1.b2();
      var \u03b41$___2 = res2.b2();
      var wellFormed$2 = \u03b41$___1;
      var acceptable$2 = \u03b41$___2;
      var $x_2 = ((wellFormed$2.a.length !== 0) ? $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T($j_java$002elang$002e$002dObject.$m_s_Predef$().iy($j_java$002elang$002e$002dObject.$m_sc_ArrayOps$().Qu(wellFormed$2, 0, 1)), "-", "-", "-") : "-");
      var $x_1 = $j_java$002elang$002e$002dObject.$m_s_Predef$();
      var xs = $j_java$002elang$002e$002dObject.$m_sc_ArrayOps$().TG(wellFormed$2, 1);
      var evidence$25__runtimeClass;
      var evidence$25__runtimeClass = $j_java$002elang$002e$002dObject.$d_T.l();
      var this$32 = $j_java$002elang$002e$002dObject.$m_s_Array$();
      var newLength = ((acceptable$2.a.length + $j_java$002elang$002e$002dObject.$m_jl_reflect_Array$().aB(xs)) | 0);
      var runtimeClass = evidence$25__runtimeClass;
      if (((runtimeClass !== null) && (runtimeClass === $j_java$002elang$002e$002dObject.$d_V.l()))) {
        var dest$1 = $j_java$002elang$002e$002dObject.$p_s_Array$__newUnitArray__I__Ajl_Void(this$32, newLength);
      } else if (runtimeClass.J.R($j_java$002elang$002e$002dObject.$objectGetClass(acceptable$2).J.Q().J)) {
        var dest$1 = (runtimeClass.J.X ? this$32.gu(acceptable$2, newLength) : $j_java$002elang$002e$002dObject.$m_ju_Arrays$().u6(acceptable$2, newLength, $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().qO(runtimeClass.J.U(0))));
      } else {
        var componentType = evidence$25__runtimeClass;
        var dest = componentType.J.U(newLength);
        $j_java$002elang$002e$002dObject.$m_s_Array$().dc(acceptable$2, 0, dest, 0, acceptable$2.a.length);
        var dest$1 = dest;
      }
      $j_java$002elang$002e$002dObject.$m_s_Array$().dc(xs, 0, dest$1, acceptable$2.a.length, $j_java$002elang$002e$002dObject.$m_jl_reflect_Array$().aB(xs));
      var variant = (($x_2 + "x-lvariant") + $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T($x_1.iy(dest$1), "-", "-", ""));
    } else {
      var variant = "";
    }
    var ext = ((!this.k4.k()) ? $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T(this.k4.a7(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$1) => {
      if ((x$1$1 !== null)) {
        var x$2 = $j_java$002elang$002e$002dObject.$uC(x$1$1.ac);
        var v = x$1$1.ad;
        return (($j_java$002elang$002e$002dObject.$cToS(x$2) + "-") + v);
      }
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x$1$1);
    }))), "-", "-", "") : "");
    var this$40 = this.vw;
    var this$42 = (this$40.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : (this$40.C(), new $j_java$002elang$002e$002dObject.$c_s_Some(("-" + this.ub()))));
    var script = (this$42.k() ? "" : this$42.C());
    this.vv = ((((this.kU() === "no") && (this.r1() === "NO")) && (this.k5 === "NY")) ? "nn-NO" : ((((("" + language) + script) + country) + ext) + variant));
  }
  return this.vv;
});
$p.f = (function(x) {
  return ((x instanceof $c_ju_Locale) && $p_ju_Locale__isEqual__ju_Locale__Z(this, x));
});
$p.m = (function() {
  if ((this.vu === 0)) {
    this.vu = $j_java$002elang$002e$002dObject.$f_T__hashCode__I(this.QI());
  }
  return this.vu;
});
function $isArrayOf_ju_Locale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dT)));
}
export { $isArrayOf_ju_Locale as $isArrayOf_ju_Locale };
var $d_ju_Locale = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Locale, "java.util.Locale", ({
  dT: 1
}));
export { $d_ju_Locale as $d_ju_Locale };
/** @constructor */
function $c_ju_Locale$() {
  this.JU = null;
  this.JV = false;
  this.vx = 0;
  this.sc = null;
  $n_ju_Locale$ = this;
  this.vx = 117;
  this.sc = $m_Llocales_DefaultLocale$().WC();
  var $x_22 = $j_java$002elang$002e$002dObject.$m_sci_Map$();
  var $x_21 = $j_java$002elang$002e$002dObject.$m_s_Predef$();
  var xs = $j_java$002eutil$002e$002dLocale$0024$002dCategory$0024.$m_ju_Locale$Category$().Yo();
  var f = ((_$5) => new $j_java$002elang$002e$002dObject.$c_T2(_$5, new $j_java$002elang$002e$002dObject.$c_s_Some(this.sc)));
  var ct__runtimeClass;
  var ct__runtimeClass = $j_java$002elang$002e$002dObject.$d_T2.l();
  var len = xs.a.length;
  var componentType = ct__runtimeClass;
  var ys = componentType.J.U(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $x_2 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_1 = i;
        var x0 = xs.a[i];
        $x_2.F(ys, $x_1, f(x0));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
      while ((i < len)) {
        var $x_4 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_3 = i;
        var x0$1 = xs.a[i];
        $x_4.F(ys, $x_3, f(x0$1));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
      while ((i < len)) {
        var $x_6 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_5 = i;
        var x0$2 = xs.a[i];
        $x_6.F(ys, $x_5, f(x0$2));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
      while ((i < len)) {
        var $x_10 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_9 = i;
        var $x_7 = xs.a;
        var $x_8 = (i << 1);
        var x0$3_$_lo = $x_7[$x_8];
        var x0$3_$_hi = $x_7[(($x_8 + 1) | 0)];
        $x_10.F(ys, $x_9, f($j_java$002elang$002e$002dObject.$bL(x0$3_$_lo, x0$3_$_hi)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
      while ((i < len)) {
        var $x_12 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_11 = i;
        var x0$4 = xs.a[i];
        $x_12.F(ys, $x_11, f(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
      while ((i < len)) {
        var $x_14 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_13 = i;
        var x0$5 = xs.a[i];
        $x_14.F(ys, $x_13, f($j_java$002elang$002e$002dObject.$bC(x0$5)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
      while ((i < len)) {
        var $x_16 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_15 = i;
        var x0$6 = xs.a[i];
        $x_16.F(ys, $x_15, f(x0$6));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
      while ((i < len)) {
        var $x_18 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_17 = i;
        var x0$7 = xs.a[i];
        $x_18.F(ys, $x_17, f(x0$7));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
      while ((i < len)) {
        var $x_20 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_19 = i;
        var x0$8 = xs.a[i];
        $x_20.F(ys, $x_19, f(x0$8));
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(xs);
    }
  }
  $x_22.jm($x_21.iy(ys));
}
export { $c_ju_Locale$ as $c_ju_Locale$ };
$p = $c_ju_Locale$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_Locale$;
/** @constructor */
function $h_ju_Locale$() {
}
export { $h_ju_Locale$ as $h_ju_Locale$ };
$h_ju_Locale$.prototype = $p;
$p.RM = (function() {
  if ((!this.JV)) {
    this.JU = $m_Llocales_LocalesDb$().A5.yc();
    this.JV = true;
  }
  return this.JU;
});
$p.kP = (function(regex, s) {
  if ((s !== null)) {
    var x32 = regex.Yg(s);
    if ((!x32.k())) {
      if ((x32.C().cf(0) === 0)) {
        return true;
      }
    }
  }
  return false;
});
$p.O8 = (function(l) {
  return this.kP($j_java$002elang$002e$002dObject.$m_sc_StringOps$().l9("[a-zA-Z]{2,8}"), l);
});
$p.SI = (function(l) {
  return this.kP($j_java$002elang$002e$002dObject.$m_sc_StringOps$().l9("[a-zA-Z]{4}"), l);
});
$p.O9 = (function(l) {
  return (this.kP($j_java$002elang$002e$002dObject.$m_sc_StringOps$().l9("[a-zA-Z]{2}"), l) || this.kP($j_java$002elang$002e$002dObject.$m_sc_StringOps$().l9("[0-9]{3}"), l));
});
$p.SG = (function(l) {
  return this.kP($j_java$002elang$002e$002dObject.$m_sc_StringOps$().l9("[0-9a-zA-Z]{1,8}"), l);
});
$p.Bf = (function(l) {
  return (this.kP($j_java$002elang$002e$002dObject.$m_sc_StringOps$().l9("[0-9][0-9a-zA-Z]{3}"), l) || this.kP($j_java$002elang$002e$002dObject.$m_sc_StringOps$().l9("[0-9a-zA-Z]{5,8}"), l));
});
$p.SJ = (function(l) {
  var parts = $j_java$002elang$002e$002dObject.$f_T__split__T__I__AT(l, "-|_", 0);
  var i = 0;
  while ((i < parts.a.length)) {
    var x1 = i;
    if ((!this.Bf(parts.a[x1]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
var $d_ju_Locale$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Locale$, "java.util.Locale$", ({
  na: 1
}));
export { $d_ju_Locale$ as $d_ju_Locale$ };
var $n_ju_Locale$;
function $m_ju_Locale$() {
  if ((!$n_ju_Locale$)) {
    $n_ju_Locale$ = new $c_ju_Locale$();
  }
  return $n_ju_Locale$;
}
export { $m_ju_Locale$ as $m_ju_Locale$ };
/** @constructor */
function $c_ju_Locale$Builder() {
  this.gY = null;
  this.gY = new $c_ju_Locale$LocaleBuilder(true, $j_java$002elang$002e$002dObject.$m_s_None$(), $j_java$002elang$002e$002dObject.$m_s_None$(), $j_java$002elang$002e$002dObject.$m_s_None$(), $j_java$002elang$002e$002dObject.$m_s_None$(), $j_java$002elang$002e$002dObject.$m_sc_Map$().br(), $j_java$002elang$002e$002dObject.$m_sc_Map$().br(), $j_java$002elang$002e$002dObject.$m_sc_Set$().br());
}
export { $c_ju_Locale$Builder as $c_ju_Locale$Builder };
$p = $c_ju_Locale$Builder.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_Locale$Builder;
/** @constructor */
function $h_ju_Locale$Builder() {
}
export { $h_ju_Locale$Builder as $h_ju_Locale$Builder };
$h_ju_Locale$Builder.prototype = $p;
$p.Qj = (function(language) {
  var this$1 = this.gY.VL(language);
  if (this$1.k()) {
    throw $j_java$002eutil$002e$002dIllformed$002dLocale$002dException.$ct_ju_IllformedLocaleException__T__(new $j_java$002eutil$002e$002dIllformed$002dLocale$002dException.$c_ju_IllformedLocaleException(), ("Invalid language " + language));
  }
  this.gY = this$1.C();
  return this;
});
$p.Qn = (function(script) {
  var this$1 = this.gY.Xp(script);
  if (this$1.k()) {
    throw $j_java$002eutil$002e$002dIllformed$002dLocale$002dException.$ct_ju_IllformedLocaleException__T__(new $j_java$002eutil$002e$002dIllformed$002dLocale$002dException.$c_ju_IllformedLocaleException(), ("Invalid script " + script));
  }
  this.gY = this$1.C();
  return this;
});
$p.Ql = (function(region) {
  var this$1 = this.gY.WO(region);
  if (this$1.k()) {
    throw $j_java$002eutil$002e$002dIllformed$002dLocale$002dException.$ct_ju_IllformedLocaleException__T__(new $j_java$002eutil$002e$002dIllformed$002dLocale$002dException.$c_ju_IllformedLocaleException(), ("Invalid region " + region));
  }
  this.gY = this$1.C();
  return this;
});
$p.Qp = (function(variant) {
  var this$1 = this.gY.Ys(variant);
  if (this$1.k()) {
    throw $j_java$002eutil$002e$002dIllformed$002dLocale$002dException.$ct_ju_IllformedLocaleException__T__(new $j_java$002eutil$002e$002dIllformed$002dLocale$002dException.$c_ju_IllformedLocaleException(), ("Invalid variant " + variant));
  }
  this.gY = this$1.C();
  return this;
});
$p.x4 = (function() {
  return this.gY.x4();
});
var $d_ju_Locale$Builder = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Locale$Builder, "java.util.Locale$Builder", ({
  nc: 1
}));
export { $d_ju_Locale$Builder as $d_ju_Locale$Builder };
/** @constructor */
function $c_Llocales_DefaultLocale$() {
  this.Kd = null;
  this.Ke = false;
}
export { $c_Llocales_DefaultLocale$ as $c_Llocales_DefaultLocale$ };
$p = $c_Llocales_DefaultLocale$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_DefaultLocale$;
/** @constructor */
function $h_Llocales_DefaultLocale$() {
}
export { $h_Llocales_DefaultLocale$ as $h_Llocales_DefaultLocale$ };
$h_Llocales_DefaultLocale$.prototype = $p;
$p.Yt = (function() {
  if ((!this.Ke)) {
    this.Kd = window;
    this.Ke = true;
  }
  return this.Kd;
});
$p.WC = (function() {
  try {
    var lang = new $j_java$002elang$002e$002dObject.$c_s_Some(this.Yt().navigator.language);
  } catch (e) {
    var lang = $j_java$002elang$002e$002dObject.$m_s_None$();
  }
  if (lang.k()) {
    var $x_1 = true;
  } else {
    var x0 = lang.C();
    var $x_1 = $m_Llocales_LocalesDb$().Kf.ae(x0);
  }
  if ($x_1) {
    var this$2 = lang;
  } else {
    var this$2 = $j_java$002elang$002e$002dObject.$m_s_None$();
  }
  var l = (this$2.k() ? "en" : this$2.C());
  var this$3 = $m_Llocales_LocalesDb$().VQ(l);
  return (this$3.k() ? $m_Llocales_LocalesDb$().A5.yc() : this$3.C());
});
var $d_Llocales_DefaultLocale$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_DefaultLocale$, "locales.DefaultLocale$", ({
  nA: 1
}));
export { $d_Llocales_DefaultLocale$ as $d_Llocales_DefaultLocale$ };
var $n_Llocales_DefaultLocale$;
function $m_Llocales_DefaultLocale$() {
  if ((!$n_Llocales_DefaultLocale$)) {
    $n_Llocales_DefaultLocale$ = new $c_Llocales_DefaultLocale$();
  }
  return $n_Llocales_DefaultLocale$;
}
export { $m_Llocales_DefaultLocale$ as $m_Llocales_DefaultLocale$ };
/** @constructor */
function $c_Llocales_LocalesDb$() {
  this.sg = null;
  this.A5 = null;
  this.Kf = null;
  $n_Llocales_LocalesDb$ = this;
  var this$3 = $j_scala$002escalajs$002ereflect$002e$002dReflect$0024.$m_sjs_reflect_Reflect$().NC.S("locales.cldr.data.LocalesProvider$");
  var this$5 = (this$3.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some(this$3.C().YP()));
  this.sg = (this$5.k() ? $m_Llocales_cldr_fallback_LocalesProvider$() : this$5.C());
  this.A5 = $m_Llocales_cldr_fallback_data_\uff3froot$();
  $j_locales$002ecldr$002efallback$002edata$002enumericsystems$0024.$m_Llocales_cldr_fallback_data_numericsystems$().xC();
  this.Kf = this.sg.Pz();
  this.sg.VZ();
  this.sg.To();
}
export { $c_Llocales_LocalesDb$ as $c_Llocales_LocalesDb$ };
$p = $c_Llocales_LocalesDb$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_LocalesDb$;
/** @constructor */
function $h_Llocales_LocalesDb$() {
}
export { $h_Llocales_LocalesDb$ as $h_Llocales_LocalesDb$ };
$h_Llocales_LocalesDb$.prototype = $p;
$p.VQ = (function(languageTag) {
  if ((languageTag === "und")) {
    return new $j_java$002elang$002e$002dObject.$c_s_Some($m_ju_Locale$().RM());
  } else {
    var this$2 = this.sg.Pz().S(languageTag);
    return (this$2.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some(this$2.C().yc()));
  }
});
var $d_Llocales_LocalesDb$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_LocalesDb$, "locales.LocalesDb$", ({
  nB: 1
}));
export { $d_Llocales_LocalesDb$ as $d_Llocales_LocalesDb$ };
var $n_Llocales_LocalesDb$;
function $m_Llocales_LocalesDb$() {
  if ((!$n_Llocales_LocalesDb$)) {
    $n_Llocales_LocalesDb$ = new $c_Llocales_LocalesDb$();
  }
  return $n_Llocales_LocalesDb$;
}
export { $m_Llocales_LocalesDb$ as $m_Llocales_LocalesDb$ };
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  this.Kg = null;
  this.Kh = false;
}
export { $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$ as $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$ };
$p = $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
}
export { $h_Llocales_cldr_fallback_data_\uff3fall\uff3f$ as $h_Llocales_cldr_fallback_data_\uff3fall\uff3f$ };
$h_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype = $p;
$p.Sd = (function() {
  if ((!this.Kh)) {
    this.Kg = new ($d_Llocales_cldr_LDML.r().C)([$m_Llocales_cldr_fallback_data_\uff3fen$(), $m_Llocales_cldr_fallback_data_\uff3froot$()]);
    this.Kh = true;
  }
  return this.Kg;
});
var $d_Llocales_cldr_fallback_data_\uff3fall\uff3f$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_fallback_data_\uff3fall\uff3f$, "locales.cldr.fallback.data._all_$", ({
  nF: 1
}));
export { $d_Llocales_cldr_fallback_data_\uff3fall\uff3f$ as $d_Llocales_cldr_fallback_data_\uff3fall\uff3f$ };
var $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
function $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3fall\uff3f$)) {
    $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$ = new $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$();
  }
  return $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
}
export { $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$ as $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$ };
/** @constructor */
function $c_Llocales_cldr_fallback_LocalesProvider$() {
}
export { $c_Llocales_cldr_fallback_LocalesProvider$ as $c_Llocales_cldr_fallback_LocalesProvider$ };
$p = $c_Llocales_cldr_fallback_LocalesProvider$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_fallback_LocalesProvider$;
/** @constructor */
function $h_Llocales_cldr_fallback_LocalesProvider$() {
}
export { $h_Llocales_cldr_fallback_LocalesProvider$ as $h_Llocales_cldr_fallback_LocalesProvider$ };
$h_Llocales_cldr_fallback_LocalesProvider$.prototype = $p;
$p.Pz = (function() {
  var $x_22 = $j_java$002elang$002e$002dObject.$m_sci_Map$();
  var $x_21 = $j_java$002elang$002e$002dObject.$m_s_Predef$();
  var xs = $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$().Sd();
  var f = ((x$1) => new $j_java$002elang$002e$002dObject.$c_T2(x$1.yc().QI(), x$1));
  var ct__runtimeClass;
  var ct__runtimeClass = $j_java$002elang$002e$002dObject.$d_T2.l();
  var len = xs.a.length;
  var componentType = ct__runtimeClass;
  var ys = componentType.J.U(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $x_2 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_1 = i;
        var x0 = xs.a[i];
        $x_2.F(ys, $x_1, f(x0));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
      while ((i < len)) {
        var $x_4 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_3 = i;
        var x0$1 = xs.a[i];
        $x_4.F(ys, $x_3, f(x0$1));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
      while ((i < len)) {
        var $x_6 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_5 = i;
        var x0$2 = xs.a[i];
        $x_6.F(ys, $x_5, f(x0$2));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
      while ((i < len)) {
        var $x_10 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_9 = i;
        var $x_7 = xs.a;
        var $x_8 = (i << 1);
        var x0$3_$_lo = $x_7[$x_8];
        var x0$3_$_hi = $x_7[(($x_8 + 1) | 0)];
        $x_10.F(ys, $x_9, f($j_java$002elang$002e$002dObject.$bL(x0$3_$_lo, x0$3_$_hi)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
      while ((i < len)) {
        var $x_12 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_11 = i;
        var x0$4 = xs.a[i];
        $x_12.F(ys, $x_11, f(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
      while ((i < len)) {
        var $x_14 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_13 = i;
        var x0$5 = xs.a[i];
        $x_14.F(ys, $x_13, f($j_java$002elang$002e$002dObject.$bC(x0$5)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
      while ((i < len)) {
        var $x_16 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_15 = i;
        var x0$6 = xs.a[i];
        $x_16.F(ys, $x_15, f(x0$6));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
      while ((i < len)) {
        var $x_18 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_17 = i;
        var x0$7 = xs.a[i];
        $x_18.F(ys, $x_17, f(x0$7));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
      while ((i < len)) {
        var $x_20 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_19 = i;
        var x0$8 = xs.a[i];
        $x_20.F(ys, $x_19, f(x0$8));
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(xs);
    }
  }
  return $x_22.jm($x_21.iy(ys));
});
$p.To = (function() {
  return new $j_locales$002ecldr$002e$002dCurrency$002dData.$c_Llocales_cldr_CurrencyData($j_java$002elang$002e$002dObject.$m_sci_Seq$().u7(), $j_java$002elang$002e$002dObject.$m_sci_Seq$().u7(), $j_java$002elang$002e$002dObject.$m_sci_Seq$().u7(), $j_java$002elang$002e$002dObject.$m_sci_Seq$().u7());
});
$p.VZ = (function() {
  var evidence$1__runtimeClass;
  var evidence$1__runtimeClass = $j_java$002elang$002e$002dObject.$d_T.l();
  var $x_2 = $j_java$002elang$002e$002dObject.$m_sci_Map$EmptyMap$();
  var evidence$1$1__runtimeClass;
  var evidence$1$1__runtimeClass = $j_java$002elang$002e$002dObject.$d_T.l();
  var $x_1 = $j_java$002elang$002e$002dObject.$m_sci_Map$EmptyMap$();
  var evidence$1$2__runtimeClass;
  var evidence$1$2__runtimeClass = $j_java$002elang$002e$002dObject.$d_T.l();
  return new $j_locales$002ecldr$002e$002dC$002dL$002dD$002dR$002dMetadata.$c_Llocales_cldr_CLDRMetadata(evidence$1__runtimeClass.J.U(0), $x_2, evidence$1$1__runtimeClass.J.U(0), $x_1, evidence$1$2__runtimeClass.J.U(0));
});
var $d_Llocales_cldr_fallback_LocalesProvider$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_fallback_LocalesProvider$, "locales.cldr.fallback.LocalesProvider$", ({
  nE: 1,
  nD: 1
}));
export { $d_Llocales_cldr_fallback_LocalesProvider$ as $d_Llocales_cldr_fallback_LocalesProvider$ };
var $n_Llocales_cldr_fallback_LocalesProvider$;
function $m_Llocales_cldr_fallback_LocalesProvider$() {
  if ((!$n_Llocales_cldr_fallback_LocalesProvider$)) {
    $n_Llocales_cldr_fallback_LocalesProvider$ = new $c_Llocales_cldr_fallback_LocalesProvider$();
  }
  return $n_Llocales_cldr_fallback_LocalesProvider$;
}
export { $m_Llocales_cldr_fallback_LocalesProvider$ as $m_Llocales_cldr_fallback_LocalesProvider$ };
/** @constructor */
function $c_ju_Locale$LocaleBuilder(strict, language, region, variant, script, extensions, unicodeExtensions, unicodeAttributes) {
  this.dB = false;
  this.fx = null;
  this.fy = null;
  this.fA = null;
  this.fz = null;
  this.eD = null;
  this.eF = null;
  this.eE = null;
  this.dB = strict;
  this.fx = language;
  this.fy = region;
  this.fA = variant;
  this.fz = script;
  this.eD = extensions;
  this.eF = unicodeExtensions;
  this.eE = unicodeAttributes;
}
export { $c_ju_Locale$LocaleBuilder as $c_ju_Locale$LocaleBuilder };
$p = $c_ju_Locale$LocaleBuilder.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_Locale$LocaleBuilder;
/** @constructor */
function $h_ju_Locale$LocaleBuilder() {
}
export { $h_ju_Locale$LocaleBuilder as $h_ju_Locale$LocaleBuilder };
$h_ju_Locale$LocaleBuilder.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$f_T__hashCode__I("LocaleBuilder"));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (this.dB ? 1231 : 1237));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.fx));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.fy));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.fA));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.fz));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.eD));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.eF));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.eE));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 8);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_ju_Locale$LocaleBuilder)) {
    if ((this.dB === x$0.dB)) {
      var x = this.fx;
      var x$2 = x$0.fx;
      var $x_6 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3 = this.fy;
      var x$4 = x$0.fy;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.fA;
      var x$6 = x$0.fA;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.fz;
      var x$8 = x$0.fz;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.eD;
      var x$10 = x$0.eD;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.eF;
      var x$12 = x$0.eF;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.eE;
      var x$14 = x$0.eE;
      return ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 8;
});
$p.o = (function() {
  return "LocaleBuilder";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.dB;
      break;
    }
    case 1: {
      return this.fx;
      break;
    }
    case 2: {
      return this.fy;
      break;
    }
    case 3: {
      return this.fA;
      break;
    }
    case 4: {
      return this.fz;
      break;
    }
    case 5: {
      return this.eD;
      break;
    }
    case 6: {
      return this.eF;
      break;
    }
    case 7: {
      return this.eE;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.VL = (function(language) {
  if (((language === null) || (language === ""))) {
    var language$3 = $j_java$002elang$002e$002dObject.$m_s_None$();
    return new $j_java$002elang$002e$002dObject.$c_s_Some(new $c_ju_Locale$LocaleBuilder(this.dB, language$3, this.fy, this.fA, this.fz, this.eD, this.eF, this.eE));
  } else if (((!this.dB) || $m_ju_Locale$().O8(language))) {
    var language$4 = new $j_java$002elang$002e$002dObject.$c_s_Some(language.toLowerCase());
    return new $j_java$002elang$002e$002dObject.$c_s_Some(new $c_ju_Locale$LocaleBuilder(this.dB, language$4, this.fy, this.fA, this.fz, this.eD, this.eF, this.eE));
  } else {
    return $j_java$002elang$002e$002dObject.$m_s_None$();
  }
});
$p.Xp = (function(script) {
  if (((script === null) || (script === ""))) {
    var script$5 = $j_java$002elang$002e$002dObject.$m_s_None$();
    return new $j_java$002elang$002e$002dObject.$c_s_Some(new $c_ju_Locale$LocaleBuilder(this.dB, this.fx, this.fy, this.fA, script$5, this.eD, this.eF, this.eE));
  } else if (((!this.dB) || $m_ju_Locale$().SI(script))) {
    var script$6 = new $j_java$002elang$002e$002dObject.$c_s_Some(($j_java$002elang$002e$002dObject.$cToS($j_java$002elang$002e$002dObject.$m_jl_Character$().yd(script.charCodeAt(0))) + script.substring(1)));
    return new $j_java$002elang$002e$002dObject.$c_s_Some(new $c_ju_Locale$LocaleBuilder(this.dB, this.fx, this.fy, this.fA, script$6, this.eD, this.eF, this.eE));
  } else {
    return $j_java$002elang$002e$002dObject.$m_s_None$();
  }
});
$p.WO = (function(region) {
  if (((region === null) || (region === ""))) {
    var region$5 = $j_java$002elang$002e$002dObject.$m_s_None$();
    return new $j_java$002elang$002e$002dObject.$c_s_Some(new $c_ju_Locale$LocaleBuilder(this.dB, this.fx, region$5, this.fA, this.fz, this.eD, this.eF, this.eE));
  } else if (((!this.dB) || $m_ju_Locale$().O9(region))) {
    var region$6 = new $j_java$002elang$002e$002dObject.$c_s_Some(region.toUpperCase());
    return new $j_java$002elang$002e$002dObject.$c_s_Some(new $c_ju_Locale$LocaleBuilder(this.dB, this.fx, region$6, this.fA, this.fz, this.eD, this.eF, this.eE));
  } else {
    return $j_java$002elang$002e$002dObject.$m_s_None$();
  }
});
$p.Ys = (function(variant) {
  if (((variant === null) || (variant === ""))) {
    var variant$10 = $j_java$002elang$002e$002dObject.$m_s_None$();
    return new $j_java$002elang$002e$002dObject.$c_s_Some(new $c_ju_Locale$LocaleBuilder(this.dB, this.fx, this.fy, variant$10, this.fz, this.eD, this.eF, this.eE));
  } else if (((!this.dB) || $m_ju_Locale$().SJ(variant))) {
    var variant$11 = new $j_java$002elang$002e$002dObject.$c_s_Some(variant.split("-").join("_"));
    return new $j_java$002elang$002e$002dObject.$c_s_Some(new $c_ju_Locale$LocaleBuilder(this.dB, this.fx, this.fy, variant$11, this.fz, this.eD, this.eF, this.eE));
  } else {
    return $j_java$002elang$002e$002dObject.$m_s_None$();
  }
});
$p.x4 = (function() {
  var this$1 = this.fx;
  var $x_2 = (this$1.k() ? "" : this$1.C());
  var this$2 = this.fy;
  var $x_1 = (this$2.k() ? "" : this$2.C());
  var this$3 = this.fA;
  return new $c_ju_Locale($x_2, $x_1, (this$3.k() ? "" : this$3.C()), this.fz, this.eD, this.eF, this.eE, ($m_ju_Locale$(), true));
});
function $isArrayOf_ju_Locale$LocaleBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dU)));
}
export { $isArrayOf_ju_Locale$LocaleBuilder as $isArrayOf_ju_Locale$LocaleBuilder };
var $d_ju_Locale$LocaleBuilder = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Locale$LocaleBuilder, "java.util.Locale$LocaleBuilder", ({
  dU: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_ju_Locale$LocaleBuilder as $d_ju_Locale$LocaleBuilder };
function $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__($thiz, parent, locale, defaultNS, digitSymbols, calendarSymbols, calendarPatterns, currencies, numberPatterns) {
  $thiz.mb = parent;
  $thiz.eG = locale;
  $thiz.m8 = defaultNS;
  $thiz.m9 = digitSymbols;
  $thiz.m6 = calendarSymbols;
  $thiz.m5 = calendarPatterns;
  $thiz.m7 = currencies;
  $thiz.ma = numberPatterns;
  var m = $j_scala$002ecollection$002emutable$002e$002dMap$0024.$m_scm_Map$().br();
  var it = currencies.s();
  while (it.i()) {
    var elem = it.e();
    var key = elem.YK();
    m.UT(key, new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      $j_java$002elang$002e$002dObject.$m_sci_List$();
      return new $j_java$002elang$002e$002dObject.$c_scm_ListBuffer();
    }))).aG(elem);
  }
  var result = $j_java$002elang$002e$002dObject.$m_sci_HashMap$().qt;
  var mapIt = m.s();
  while (mapIt.i()) {
    var x1 = mapIt.e();
    var \u03b42$ = x1;
    var k$2 = \u03b42$.ac;
    var v$2 = \u03b42$.ad;
    result = result.ln(k$2, v$2.b2());
  }
  var this$3 = result;
  $j_java$002elang$002e$002dObject.$m_sci_HashMap$();
  var b = new $j_java$002elang$002e$002dObject.$c_sci_HashMapBuilder();
  var it$1 = this$3.s();
  while (it$1.i()) {
    var x0 = it$1.e();
    matchResult10: {
      var elem$1___1;
      var elem$1___2;
      if ((x0 !== null)) {
        var code = x0.ac;
        var list = x0.ad;
        var elem$1___1 = code.toUpperCase();
        var elem$1___2 = list.E();
        break matchResult10;
      }
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x0);
    }
    $j_java$002elang$002e$002dObject.$p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var h = $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(elem$1___1);
    var im = $j_java$002elang$002e$002dObject.$m_sc_Hashing$().ay(h);
    b.lk(b.gi, elem$1___1, elem$1___2, h, im, 0);
  }
  b.y3();
  return $thiz;
}
export { $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__ as $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__ };
/** @constructor */
function $c_Llocales_cldr_LDML() {
  this.mb = null;
  this.eG = null;
  this.m8 = null;
  this.m9 = null;
  this.m6 = null;
  this.m5 = null;
  this.m7 = null;
  this.ma = null;
}
export { $c_Llocales_cldr_LDML as $c_Llocales_cldr_LDML };
$p = $c_Llocales_cldr_LDML.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_LDML;
/** @constructor */
function $h_Llocales_cldr_LDML() {
}
export { $h_Llocales_cldr_LDML as $h_Llocales_cldr_LDML };
$h_Llocales_cldr_LDML.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_LDML)) {
    var x = this.mb;
    var x$2 = x$0.mb;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.eG;
      var x$4 = x$0.eG;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.m8;
      var x$6 = x$0.m8;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.m9;
      var x$8 = x$0.m9;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.m6;
      var x$10 = x$0.m6;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.m5;
      var x$12 = x$0.m5;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.m7;
      var x$14 = x$0.m7;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.ma;
      var x$16 = x$0.ma;
      return ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 8;
});
$p.o = (function() {
  return "LDML";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.mb;
      break;
    }
    case 1: {
      return this.eG;
      break;
    }
    case 2: {
      return this.m8;
      break;
    }
    case 3: {
      return this.m9;
      break;
    }
    case 4: {
      return this.m6;
      break;
    }
    case 5: {
      return this.m5;
      break;
    }
    case 6: {
      return this.m7;
      break;
    }
    case 7: {
      return this.ma;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.yc = (function() {
  if ((this.eG.mc === "root")) {
    var $x_3 = new $c_ju_Locale$Builder().Qj("");
    var this$1 = this.eG.me;
    var $x_2 = $x_3.Ql((this$1.k() ? "" : this$1.C()));
    var this$2 = this.eG.md;
    var $x_1 = $x_2.Qn((this$2.k() ? "" : this$2.C()));
    var this$3 = this.eG.mf;
    return $x_1.Qp((this$3.k() ? "" : this$3.C())).x4();
  } else {
    var $x_6 = new $c_ju_Locale$Builder().Qj(this.eG.mc);
    var this$4 = this.eG.me;
    var $x_5 = $x_6.Ql((this$4.k() ? "" : this$4.C()));
    var this$5 = this.eG.md;
    var $x_4 = $x_5.Qn((this$5.k() ? "" : this$5.C()));
    var this$6 = this.eG.mf;
    return $x_4.Qp((this$6.k() ? "" : this$6.C())).x4();
  }
});
function $isArrayOf_Llocales_cldr_LDML(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bR)));
}
export { $isArrayOf_Llocales_cldr_LDML as $isArrayOf_Llocales_cldr_LDML };
var $d_Llocales_cldr_LDML = new $j_java$002elang$002e$002dObject.$TypeData().i(0, "locales.cldr.LDML", ({
  bR: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Llocales_cldr_LDML as $d_Llocales_cldr_LDML };
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3fen$() {
  this.mb = null;
  this.eG = null;
  this.m8 = null;
  this.m9 = null;
  this.m6 = null;
  this.m5 = null;
  this.m7 = null;
  this.ma = null;
  var $x_11 = new $j_java$002elang$002e$002dObject.$c_s_Some($m_Llocales_cldr_fallback_data_\uff3froot$());
  var $x_10 = new $j_locales$002ecldr$002e$002dL$002dD$002dM$002dL$002dLocale.$c_Llocales_cldr_LDMLLocale("en", $j_java$002elang$002e$002dObject.$m_s_None$(), $j_java$002elang$002e$002dObject.$m_s_None$(), $j_java$002elang$002e$002dObject.$m_s_None$());
  var $x_9 = $j_java$002elang$002e$002dObject.$m_s_None$();
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_locales$002ecldr$002e$002dSymbols.$d_Llocales_cldr_Symbols.r().C)([new $j_locales$002ecldr$002e$002dSymbols.$c_Llocales_cldr_Symbols($j_locales$002ecldr$002efallback$002edata$002enumericsystems$0024.$m_Llocales_cldr_fallback_data_numericsystems$().xC(), $j_java$002elang$002e$002dObject.$m_s_None$(), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(46)), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(44)), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(59)), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(37)), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(45)), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(8240)), new $j_java$002elang$002e$002dObject.$c_s_Some("\u221e"), new $j_java$002elang$002e$002dObject.$c_s_Some("NaN"), new $j_java$002elang$002e$002dObject.$c_s_Some("E"))]));
  var $x_8 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$1 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T.r().C)(["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]));
  var $x_7 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$1);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$2 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T.r().C)(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]));
  var $x_6 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$2);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$3 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T.r().C)(["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]));
  var $x_5 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$3);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$4 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T.r().C)(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]));
  var $x_4 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$4);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$5 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T.r().C)(["AM", "PM"]));
  var $x_3 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$5);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$6 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T.r().C)(["BC", "AD"]));
  var $x_2 = new $j_java$002elang$002e$002dObject.$c_s_Some(new $j_locales$002ecldr$002e$002dCalendar$002dSymbols.$c_Llocales_cldr_CalendarSymbols($x_7, $x_6, $x_5, $x_4, $x_3, $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$6)));
  var $x_1 = new $j_java$002elang$002e$002dObject.$c_s_Some(($j_locales$002ecldr$002e$002dCalendar$002dPatterns$0024.$m_Llocales_cldr_CalendarPatterns$(), new $j_locales$002ecldr$002e$002dCalendar$002dPatterns.$c_Llocales_cldr_CalendarPatterns($j_java$002elang$002e$002dObject.$m_sci_Map$().jm($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T2.r().C)([new $j_java$002elang$002e$002dObject.$c_T2(0, "EEEE, MMMM d, y"), new $j_java$002elang$002e$002dObject.$c_T2(1, "MMMM d, y"), new $j_java$002elang$002e$002dObject.$c_T2(2, "MMM d, y"), new $j_java$002elang$002e$002dObject.$c_T2(3, "M/d/yy")]))), $j_java$002elang$002e$002dObject.$m_sci_Map$().jm($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T2.r().C)([new $j_java$002elang$002e$002dObject.$c_T2(0, "h:mm:ss a zzzz"), new $j_java$002elang$002e$002dObject.$c_T2(1, "h:mm:ss a z"), new $j_java$002elang$002e$002dObject.$c_T2(2, "h:mm:ss a"), new $j_java$002elang$002e$002dObject.$c_T2(3, "h:mm a")]))))));
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$9 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().r0(new ($j_java$002elang$002e$002dObject.$d_sr_Nothing$.r().C)([]));
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $x_11, $x_10, $x_9, $x_8, $x_2, $x_1, $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$9), new $j_locales$002ecldr$002e$002dNumber$002dPatterns.$c_Llocales_cldr_NumberPatterns(new $j_java$002elang$002e$002dObject.$c_s_Some("#,##0.###"), new $j_java$002elang$002e$002dObject.$c_s_Some("#,##0%"), new $j_java$002elang$002e$002dObject.$c_s_Some("\u00a4#,##0.00;(\u00a4#,##0.00)")));
}
export { $c_Llocales_cldr_fallback_data_\uff3fen$ as $c_Llocales_cldr_fallback_data_\uff3fen$ };
$p = $c_Llocales_cldr_fallback_data_\uff3fen$.prototype = new $h_Llocales_cldr_LDML();
$p.constructor = $c_Llocales_cldr_fallback_data_\uff3fen$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3fen$() {
}
export { $h_Llocales_cldr_fallback_data_\uff3fen$ as $h_Llocales_cldr_fallback_data_\uff3fen$ };
$h_Llocales_cldr_fallback_data_\uff3fen$.prototype = $p;
var $d_Llocales_cldr_fallback_data_\uff3fen$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_fallback_data_\uff3fen$, "locales.cldr.fallback.data._en$", ({
  nG: 1,
  bR: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Llocales_cldr_fallback_data_\uff3fen$ as $d_Llocales_cldr_fallback_data_\uff3fen$ };
var $n_Llocales_cldr_fallback_data_\uff3fen$;
function $m_Llocales_cldr_fallback_data_\uff3fen$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3fen$)) {
    $n_Llocales_cldr_fallback_data_\uff3fen$ = new $c_Llocales_cldr_fallback_data_\uff3fen$();
  }
  return $n_Llocales_cldr_fallback_data_\uff3fen$;
}
export { $m_Llocales_cldr_fallback_data_\uff3fen$ as $m_Llocales_cldr_fallback_data_\uff3fen$ };
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3froot$() {
  this.mb = null;
  this.eG = null;
  this.m8 = null;
  this.m9 = null;
  this.m6 = null;
  this.m5 = null;
  this.m7 = null;
  this.ma = null;
  var $x_11 = $j_java$002elang$002e$002dObject.$m_s_None$();
  var $x_10 = new $j_locales$002ecldr$002e$002dL$002dD$002dM$002dL$002dLocale.$c_Llocales_cldr_LDMLLocale("root", $j_java$002elang$002e$002dObject.$m_s_None$(), $j_java$002elang$002e$002dObject.$m_s_None$(), $j_java$002elang$002e$002dObject.$m_s_None$());
  var $x_9 = new $j_java$002elang$002e$002dObject.$c_s_Some($j_locales$002ecldr$002efallback$002edata$002enumericsystems$0024.$m_Llocales_cldr_fallback_data_numericsystems$().xC());
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_locales$002ecldr$002e$002dSymbols.$d_Llocales_cldr_Symbols.r().C)([new $j_locales$002ecldr$002e$002dSymbols.$c_Llocales_cldr_Symbols($j_locales$002ecldr$002efallback$002edata$002enumericsystems$0024.$m_Llocales_cldr_fallback_data_numericsystems$().xC(), $j_java$002elang$002e$002dObject.$m_s_None$(), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(46)), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(44)), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(59)), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(37)), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(45)), new $j_java$002elang$002e$002dObject.$c_s_Some($j_java$002elang$002e$002dObject.$bC(8240)), new $j_java$002elang$002e$002dObject.$c_s_Some("\u221e"), new $j_java$002elang$002e$002dObject.$c_s_Some("NaN"), new $j_java$002elang$002e$002dObject.$c_s_Some("E"))]));
  var $x_8 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$1 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T.r().C)(["M01", "M02", "M03", "M04", "M05", "M06", "M07", "M08", "M09", "M10", "M11", "M12"]));
  var $x_7 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$1);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$2 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().r0(new ($j_java$002elang$002e$002dObject.$d_sr_Nothing$.r().C)([]));
  var $x_6 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$2);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$3 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T.r().C)(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]));
  var $x_5 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$3);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$4 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().r0(new ($j_java$002elang$002e$002dObject.$d_sr_Nothing$.r().C)([]));
  var $x_4 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$4);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$5 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().r0(new ($j_java$002elang$002e$002dObject.$d_sr_Nothing$.r().C)([]));
  var $x_3 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$5);
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$6 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T.r().C)(["BCE", "CE"]));
  var $x_2 = new $j_java$002elang$002e$002dObject.$c_s_Some(new $j_locales$002ecldr$002e$002dCalendar$002dSymbols.$c_Llocales_cldr_CalendarSymbols($x_7, $x_6, $x_5, $x_4, $x_3, $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$6)));
  var $x_1 = new $j_java$002elang$002e$002dObject.$c_s_Some(($j_locales$002ecldr$002e$002dCalendar$002dPatterns$0024.$m_Llocales_cldr_CalendarPatterns$(), new $j_locales$002ecldr$002e$002dCalendar$002dPatterns.$c_Llocales_cldr_CalendarPatterns($j_java$002elang$002e$002dObject.$m_sci_Map$().jm($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T2.r().C)([new $j_java$002elang$002e$002dObject.$c_T2(0, "y MMMM d, EEEE"), new $j_java$002elang$002e$002dObject.$c_T2(1, "y MMMM d"), new $j_java$002elang$002e$002dObject.$c_T2(2, "y MMM d"), new $j_java$002elang$002e$002dObject.$c_T2(3, "y-MM-dd")]))), $j_java$002elang$002e$002dObject.$m_sci_Map$().jm($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_java$002elang$002e$002dObject.$d_T2.r().C)([new $j_java$002elang$002e$002dObject.$c_T2(0, "HH:mm:ss zzzz"), new $j_java$002elang$002e$002dObject.$c_T2(1, "HH:mm:ss z"), new $j_java$002elang$002e$002dObject.$c_T2(2, "HH:mm:ss"), new $j_java$002elang$002e$002dObject.$c_T2(3, "HH:mm")]))))));
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var elems$9 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().r0(new ($j_java$002elang$002e$002dObject.$d_sr_Nothing$.r().C)([]));
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $x_11, $x_10, $x_9, $x_8, $x_2, $x_1, $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(elems$9), new $j_locales$002ecldr$002e$002dNumber$002dPatterns.$c_Llocales_cldr_NumberPatterns(new $j_java$002elang$002e$002dObject.$c_s_Some("#,##0.###"), new $j_java$002elang$002e$002dObject.$c_s_Some("#,##0%"), new $j_java$002elang$002e$002dObject.$c_s_Some("\u00a4\u00a0#,##0.00")));
}
export { $c_Llocales_cldr_fallback_data_\uff3froot$ as $c_Llocales_cldr_fallback_data_\uff3froot$ };
$p = $c_Llocales_cldr_fallback_data_\uff3froot$.prototype = new $h_Llocales_cldr_LDML();
$p.constructor = $c_Llocales_cldr_fallback_data_\uff3froot$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3froot$() {
}
export { $h_Llocales_cldr_fallback_data_\uff3froot$ as $h_Llocales_cldr_fallback_data_\uff3froot$ };
$h_Llocales_cldr_fallback_data_\uff3froot$.prototype = $p;
var $d_Llocales_cldr_fallback_data_\uff3froot$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_fallback_data_\uff3froot$, "locales.cldr.fallback.data._root$", ({
  nH: 1,
  bR: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Llocales_cldr_fallback_data_\uff3froot$ as $d_Llocales_cldr_fallback_data_\uff3froot$ };
var $n_Llocales_cldr_fallback_data_\uff3froot$;
function $m_Llocales_cldr_fallback_data_\uff3froot$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3froot$)) {
    $n_Llocales_cldr_fallback_data_\uff3froot$ = new $c_Llocales_cldr_fallback_data_\uff3froot$();
  }
  return $n_Llocales_cldr_fallback_data_\uff3froot$;
}
export { $m_Llocales_cldr_fallback_data_\uff3froot$ as $m_Llocales_cldr_fallback_data_\uff3froot$ };
